/**
 * Hook to access free-text field favorites (awards, exhibitions, publications, locations).
 *
 * Returns the context value when available, or undefined when used outside a provider
 * (which is the case in some isolated component tests). Consumer components should
 * gracefully degrade to a no-op render in that case rather than crashing the host.
 */

import { useContext } from 'react';
import { FieldFavoritesContext } from '../contexts/FieldFavoritesContext';

export const useFieldFavorites = () => useContext(FieldFavoritesContext);
